"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TextField = require("../../TextField");

var _utils = require("../utils");

var _dateParts3 = require("../date-parts");

var _types = require("../date-parts/types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Validates a date based on min and max values. Will call onError if provided.
 *
 * @param date - The Date object calculated for the input.
 * @param currentErrorType - The current error type to check if it has changed.
 * @param setErrorType - State updater for errorType.
 * @param hourOfDay - The hour that the generated dates have, 12 is recommended to avoid
 * daylight savings issues.
 * @param min - The min Date value.
 * @param max - The max Date value.
 */
var validateDateParts = function validateDateParts(dateParts, currentErrorType, setErrorType, min, max) {
  if (min && dateParts.isLessThan(min)) {
    if (currentErrorType !== 'min') setErrorType('min');
    return false;
  } else if (max && dateParts.isGreaterThan(max)) {
    if (currentErrorType !== 'max') setErrorType('max');
    return false;
  } else {
    if (currentErrorType !== null) setErrorType(null);
  }

  return true;
};
/**
 * Infers a date parts from a raw input string.
 *
 * @param value - The input string to infer the date parts from.
 * @param localeDateFormat - The locale date format information.
 * @param placeholder - The character used as a placeholder.
 */


var rawInputToDateParts = function rawInputToDateParts(value, localeDateFormat, placeholder) {
  var validationRegex = "[^0-9\\".concat(localeDateFormat.separator, "\\").concat(placeholder, "]");
  var cleanInput = value.replace(new RegExp(validationRegex, 'g'), '').trim();

  if (!cleanInput || !cleanInput.length || cleanInput === localeDateFormat.placeholderString) {
    return null;
  } else if (!cleanInput.includes(localeDateFormat.separator)) {
    var _dateParts = new _dateParts3.DateParts();

    _dateParts[localeDateFormat.order[0]] = parseInt(cleanInput) - (localeDateFormat.order[0] === _types.DatePartEnum.MONTH ? 1 : 0);
    return _dateParts;
  }

  return cleanInput.replaceAll(placeholder, '').split(localeDateFormat.separator).reduce(function (acc, partValueString, index) {
    if (partValueString !== '') {
      var part = localeDateFormat.order[index];
      var partValue = parseInt(partValueString);
      if (part === _types.DatePartEnum.MONTH) partValue -= 1;
      acc[part] = partValue;
      return acc;
    }

    return acc;
  }, new _dateParts3.DateParts());
};

/**
 * Gets an object that represents the cursors position in the input and date string.
 *
 * @param input - The input to analyse.
 * @param localeDateFormat - The locale date format information.
 */
var getCursorPosition = function getCursorPosition(input, localeDateFormat) {
  if (!input || input.selectionStart == null) return null;
  var value = input.selectionStart;
  var datePart = undefined;
  var formatSplit = localeDateFormat.formatString.split(localeDateFormat.separator);
  var partCounter = 0;
  var characterCounter = 0;

  var _iterator = _createForOfIteratorHelper(formatSplit),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var formatPart = _step.value;
      characterCounter += formatPart.length + 1;

      if (value <= characterCounter) {
        datePart = {
          index: partCounter,
          name: localeDateFormat.order[partCounter],
          end: -1,
          start: -1,
          cursorPosition: -1
        };
        datePart.end = characterCounter - 1;
        datePart.start = datePart.end - formatPart.length;
        datePart.cursorPosition = value - datePart.start;
        break;
      }

      partCounter += 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    value: value,
    datePart: datePart
  };
};
/**
 * Moves the cursor to specific position in input.
 *
 * @param input - The input with the date string in.
 * @param position - The position to move the cursor to.
 * @param callback - A function to call after cursor has move.
 */


var moveCursorTo = function moveCursorTo(input, position, callback) {
  if (!input) return; // Adding a fake timeout means this executes after input value is updated.

  setTimeout(function () {
    input.selectionStart = input.selectionEnd = position;
    callback && callback();
  }, 0);
};

/**
 * Applies backspace functionality to the input
 *
 * @param input - The input with the date string in.
 * @param prevValue - The input value before the change from pressing backspace.
 * @param cursorPosition - The cursor position object describing the current position.
 * @param localeDateFormat - The locale date format for the user.
 * @param placeholder - The placeholder used in the date string.
 */
var backspacePressHandler = function backspacePressHandler(input, prevValue, cursorPosition, localeDateFormat, placeholder) {
  if (!input || !prevValue || !cursorPosition || !cursorPosition.datePart || prevValue === localeDateFormat.placeholderString) {
    return {
      newValue: prevValue,
      newCursorPosition: cursorPosition.value
    };
  }

  var character = prevValue[cursorPosition.value];
  if (!character) return {
    newValue: prevValue,
    newCursorPosition: cursorPosition.value
  }; // Back track if the character is a placeholder

  if (character === placeholder) {
    return backspacePressHandler(input, prevValue, {
      value: cursorPosition.value - 1,
      datePart: _objectSpread(_objectSpread({}, cursorPosition.datePart), {}, {
        cursorPosition: cursorPosition.datePart.cursorPosition - 1
      })
    }, localeDateFormat, placeholder);
  } // Move to previous section if its a separator


  if (character === localeDateFormat.separator) {
    return {
      newValue: prevValue,
      newCursorPosition: cursorPosition.value
    };
  }

  return {
    newValue: prevValue.slice(0, cursorPosition.value) + prevValue.slice(cursorPosition.value + 1),
    newCursorPosition: cursorPosition.value + 1
  };
};
/**
 * Applies delete functionality to the input
 *
 * @param input - The input with the date string in.
 * @param prevValue - The input value before the change from pressing backspace.
 * @param cursorPosition - The cursor position object describing the current position.
 * @param localeDateFormat - The locale date format for the user.
 * @param placeholder - The placeholder used in the date string.
 */


var deletePressHandler = function deletePressHandler(input, prevValue, cursorPosition, localeDateFormat, placeholder) {
  if (!input || !prevValue || !cursorPosition || !cursorPosition.datePart || prevValue === localeDateFormat.placeholderString) {
    return {
      newValue: prevValue,
      newCursorPosition: cursorPosition.value
    };
  }

  var character = prevValue[cursorPosition.value];
  if (!character) return {
    newValue: prevValue,
    newCursorPosition: cursorPosition.value
  }; // Back track if the character is a placeholder

  if (character === placeholder) {
    return deletePressHandler(input, prevValue, {
      value: cursorPosition.value + 1,
      datePart: _objectSpread(_objectSpread({}, cursorPosition.datePart), {}, {
        cursorPosition: cursorPosition.datePart.cursorPosition + 1
      })
    }, localeDateFormat, placeholder);
  } // Move to previous section if its a separator


  if (character === localeDateFormat.separator) {
    return {
      newValue: prevValue,
      newCursorPosition: cursorPosition.value + 1
    };
  }

  return {
    newValue: prevValue.slice(0, cursorPosition.value) + prevValue.slice(cursorPosition.value + 1),
    newCursorPosition: cursorPosition.value + 1
  };
};
/**
 * Applies number input functionality to the input
 *
 * @param input - The input with the date string in.
 * @param prevValue - The input value before the change from pressing backspace.
 * @param cursorPosition - The cursor position object describing the current position.
 * @param localeDateFormat - The locale date format for the user.
 * @param placeholder - The placeholder used in the date string.
 */


var numberPressHandler = function numberPressHandler(input, prevValue, cursorPosition, localeDateFormat, placeholder) {
  var rawValue = input && input.value;

  if (rawValue == null || !cursorPosition.datePart) {
    return {
      newValue: prevValue,
      newCursorPosition: cursorPosition.value + 1
    };
  } // If input is originally empty we assume its the first part of the date


  if (prevValue === '') {
    var _dateParts2 = new _dateParts3.DateParts();

    _dateParts2[localeDateFormat.order[0]] = parseInt(rawValue);
    return {
      newValue: _dateParts2.toString(localeDateFormat.formatString, placeholder),
      newCursorPosition: cursorPosition.datePart.end
    };
  }

  var response = {
    newValue: rawValue,
    newCursorPosition: cursorPosition.value
  }; // Cap date parts if invalid

  var dateParts = rawInputToDateParts(rawValue, localeDateFormat, placeholder);

  if (dateParts) {
    var cappedDateParts = new _dateParts3.DateParts(dateParts[_types.DatePartEnum.YEAR], dateParts[_types.DatePartEnum.MONTH], dateParts[_types.DatePartEnum.DATE]);
    cappedDateParts.cap();

    if (!dateParts.isEqualTo(cappedDateParts)) {
      response.newValue = cappedDateParts.toString(localeDateFormat.formatString, placeholder);
      response.newCursorPosition = Math.min(response.newCursorPosition, cursorPosition.datePart.end);
    }
  }

  return response;
};
/**
 * Inserts/Removes relevant placeholder chars for an input value string.
 * @param response - The handler response to clean.
 * @param cursorPosition - The cursor position object describing the current position.
 * @param localeDateFormat - The locale date format for the user.
 * @param placeholder - The placeholder used in the date string.
 */


var cleanPlaceholders = function cleanPlaceholders(response, cursorPosition, localeDateFormat, placeholder) {
  if (!response.newValue || !response.newValue.length) return response;
  var formatSplit = localeDateFormat.formatString.split(localeDateFormat.separator);
  var newCursorPosition = response.newCursorPosition;
  var newValue = response.newValue.split(localeDateFormat.separator).map(function (value, index) {
    var cleanValue = value;

    if (value.length > formatSplit[index].length) {
      var lastPlaceholderIndex = cleanValue.lastIndexOf(placeholder); // Delete last placeholder if length is too long

      if (lastPlaceholderIndex >= 0) {
        cleanValue = cleanValue.slice(0, lastPlaceholderIndex) + cleanValue.slice(lastPlaceholderIndex + 1); // If we delete a placeholder before the cursor we need to move the cursor back one

        if (cursorPosition.datePart && index === cursorPosition.datePart.index && lastPlaceholderIndex < cursorPosition.datePart.cursorPosition) {
          newCursorPosition -= 1;
        }
      } // Add placeholder at start if too short

    } else if (value.length < formatSplit[index].length) {
      cleanValue = placeholder + cleanValue;
    }

    return cleanValue;
  }).join(localeDateFormat.separator);
  return {
    newValue: newValue,
    newCursorPosition: newCursorPosition
  };
};
/**
 * This provides a somewhat bare bones input for dates comprised of 3 seperate inputs.
 * The in puts are text inputs but filter out all non-numeric values, meaning it effectives
 * acts as an integer field.
 *
 * Values are limited by the `hardCapDateParts` and validated against `min` and `max` values.
 */


var DateInput = function DateInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onError = _ref.onError,
      locale = _ref.locale,
      _ref$placeholderChara = _ref.placeholderCharacter,
      placeholderCharacter = _ref$placeholderChara === void 0 ? ' ' : _ref$placeholderChara,
      min = _ref.min,
      max = _ref.max,
      resetLocalValueTrigger = _ref.resetLocalValueTrigger;
  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(value || null),
      _useState4 = _slicedToArray(_useState3, 2),
      localValue = _useState4[0],
      setLocalValue = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      localInputValue = _useState6[0],
      setLocalInputValue = _useState6[1];

  var _useState7 = (0, _react.useState)((0, _utils.getLocaleDateFormat)(placeholderCharacter, locale)),
      _useState8 = _slicedToArray(_useState7, 1),
      localeDateFormat = _useState8[0];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      errorType = _useState10[0],
      setErrorType = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      lastKeyPress = _useState12[0],
      setLastKeyPress = _useState12[1]; // Update local value if parent changes value prop.


  (0, _react.useEffect)(function () {
    var newLocalValue = value != null ? value : null;
    if (newLocalValue) newLocalValue.cap();
    setLocalValue(newLocalValue); // If its a full date validate against min/max, otherwise clear error

    newLocalValue && newLocalValue.isFullDate() ? validateDateParts(newLocalValue, errorType, setErrorType, min, max) : setErrorType(null); // Is updating errorType so dont want it included as dep
    // eslint-disable-next-line
  }, [min, max, value, resetLocalValueTrigger]); // Update local input value if local value is different to input value.

  (0, _react.useEffect)(function () {
    var inputDateParts = rawInputToDateParts(localInputValue, localeDateFormat, placeholderCharacter);

    if (!(localValue && localValue.isEqualTo(inputDateParts))) {
      setLocalInputValue(localValue ? localValue.toString(localeDateFormat.formatString, placeholderCharacter) : '');
    } // Is updating localValue so dont want it included as dep
    // eslint-disable-next-line

  }, [placeholderCharacter, localValue, localeDateFormat]); // Call onError when errorTypeChanges

  (0, _react.useEffect)(function () {
    onError && onError(errorType, localValue); // We only want to call onError with errorType change, so other deps omitted
    // eslint-disable-next-line
  }, [errorType]); // Pass through focus event

  var onInputFocus = function onInputFocus(event) {
    setIsFocused(true);
    onFocus && onFocus(event);
  }; // Pass through blur event


  var onInputBlur = function onInputBlur(event) {
    setIsFocused(false);
    onBlur && onBlur(event);
  }; // Handle change of the input


  var onInputChange = function onInputChange() {
    var cursorPosition = getCursorPosition(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current, localeDateFormat);
    if (!cursorPosition || !cursorPosition.datePart) return;
    var response = {
      newValue: localInputValue,
      newCursorPosition: cursorPosition.value - 1
    }; // Skip forward a section if a user uses the separator

    if (lastKeyPress === localeDateFormat.separator) {
      if (response.newValue && response.newValue.length) {
        response.newCursorPosition = cursorPosition.datePart.end + 1;
      } // Delete in backwards direction if user presses backspace

    } else if (lastKeyPress === 'Backspace') {
      response = backspacePressHandler(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current, localInputValue, cursorPosition, localeDateFormat, placeholderCharacter); // Delete in forwards direction if user presses delete
    } else if (lastKeyPress === 'Delete') {
      response = deletePressHandler(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current, localInputValue, cursorPosition, localeDateFormat, placeholderCharacter); // Handle inputting numeric values
    } else if ('1234567890'.includes(lastKeyPress || '')) {
      response = numberPressHandler(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current, localInputValue, cursorPosition, localeDateFormat, placeholderCharacter);
    } else {
      return;
    } // Make sure there are correct placeholders for everything


    response = cleanPlaceholders(response, cursorPosition, localeDateFormat, placeholderCharacter); // Show the input placeholder if no values are input

    if (response.newValue === localeDateFormat.placeholderString) {
      response.newValue = '';
    } // Generate new date parts and infer new date.


    var newDateParts = rawInputToDateParts(response.newValue, localeDateFormat, placeholderCharacter); // Check complete data against min/max

    var isValid = true;

    if (newDateParts && newDateParts.isFullDate()) {
      isValid = validateDateParts(newDateParts, errorType, setErrorType, min, max);
    } else {
      setErrorType(null);
    }

    setLocalValue; // Call onChange if there is no error and the value is different from current value.

    if (isValid && !(value && value.isEqualTo(newDateParts))) {
      onChange(newDateParts);
    } // Update local date


    if (!(localValue && localValue.isEqualTo(newDateParts))) {
      setLocalValue(newDateParts);
    } // Update input value


    setLocalInputValue(response.newValue); // Reset cursor position to where it should be

    moveCursorTo(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current, Math.max(response.newCursorPosition, 1));
  }; // Keep track of the most recent key press


  var onInputKeyDown = function onInputKeyDown(event) {
    setLastKeyPress(event.key);
  };

  return /*#__PURE__*/_react["default"].createElement(_TextField.Input, {
    ref: inputRef,
    value: localInputValue,
    placeholder: localeDateFormat.formatString,
    type: "text",
    onClick: onClick,
    onChange: onInputChange,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    onKeyDown: onInputKeyDown,
    focused: isFocused,
    hasValue: !!localValue,
    hasLeftDecor: false,
    hasRightDecor: false
  });
};

exports.DateInput = DateInput;